import React from 'react';

const ProductFilters = ({ 
  filters, 
  categories, 
  onFilterChange, 
  onClearFilters, 
  showFilters 
}) => {
  return (
    <div className={`lg:w-64 ${showFilters ? 'block' : 'hidden lg:block'}`}>
      <div className="bg-pureWhite rounded-lg p-6 shadow-sm">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-semibold text-slateText">Filters</h3>
          <button
            onClick={onClearFilters}
            className="text-pinkAccent text-sm hover:underline"
          >
            Clear All
          </button>
        </div>

        {/* Category Filter */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-slateText mb-2">
            Category
          </label>
          <select
            value={filters.category}
            onChange={(e) => onFilterChange('category', e.target.value)}
            className="w-full p-2 border border-lightGray rounded-lg focus:outline-none focus:ring-2 focus:ring-pinkAccent"
          >
            <option value="">All Categories</option>
            {categories.map(cat => (
              <option key={cat.value} value={cat.value}>
                {cat.label}
              </option>
            ))}
          </select>
        </div>

        {/* Price Range */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-slateText mb-2">
            Price Range
          </label>
          <div className="flex gap-2">
            <input
              type="number"
              placeholder="Min"
              value={filters.minPrice}
              onChange={(e) => onFilterChange('minPrice', e.target.value)}
              className="w-full p-2 border border-lightGray rounded-lg focus:outline-none focus:ring-2 focus:ring-pinkAccent"
            />
            <input
              type="number"
              placeholder="Max"
              value={filters.maxPrice}
              onChange={(e) => onFilterChange('maxPrice', e.target.value)}
              className="w-full p-2 border border-lightGray rounded-lg focus:outline-none focus:ring-2 focus:ring-pinkAccent"
            />
          </div>
        </div>

        {/* Sort Options */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-slateText mb-2">
            Sort By
          </label>
          <select
            value={`${filters.sort}-${filters.order}`}
            onChange={(e) => {
              const [sort, order] = e.target.value.split('-');
              onFilterChange('sort', sort);
              onFilterChange('order', order);
            }}
            className="w-full p-2 border border-lightGray rounded-lg focus:outline-none focus:ring-2 focus:ring-pinkAccent"
          >
            <option value="createdAt-desc">Newest First</option>
            <option value="createdAt-asc">Oldest First</option>
            <option value="price-asc">Price: Low to High</option>
            <option value="price-desc">Price: High to Low</option>
            <option value="name-asc">Name: A to Z</option>
            <option value="name-desc">Name: Z to A</option>
            <option value="rating-desc">Highest Rated</option>
          </select>
        </div>

        {/* Featured Products Toggle */}
        <div className="mb-4">
          <label className="flex items-center">
            <input
              type="checkbox"
              checked={filters.featured}
              onChange={(e) => onFilterChange('featured', e.target.checked)}
              className="mr-2 text-pinkAccent focus:ring-pinkAccent"
            />
            <span className="text-sm text-slateText">Featured Only</span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default ProductFilters;